export const ColorHighLights = [
  { id: 'MAGENTA', label: 'purple', color: '#C454C6' },
  { id: 'CYAN', label: 'cyan', color: '#27E9E8' },
  { id: 'GREEN', label: 'green', color: '#2DA950' },
  { id: 'BLUE', label: 'blue', color: '#1675D0' },
  { id: 'RED', label: 'red', color: '#CE4149' },
  { id: 'YELLOW', label: 'yellow', color: '#FED22E' },
  { id: 'GRAY', label: 'gray', color: '#F2F2F2' },
];
